import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";
import TablePaginationBar from "./TablePaginationBar";

const AuditLogs = () => {
  const user = useSelector((state) => state?.user);

  const [currentLogs, setCurrentLogs] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [logs, setLogs] = useState([]);
  const recordsPerPage = 10;
  const [viewAll, setViewAll] = useState(false);

  const paginate = (page) => setCurrentPage(page);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/logs/all`,
          {
            headers: {
              Authorization: `Bearer ${user.user?.token}`,
            },
          }
        );

        if (response.status === 200) {
          setLogs(response.data.data);
        }
      } catch (error) {
        console.error("🚀 -> fetchLogs -> error:", error);
      }
    };

    fetchLogs();
  }, [user.user?.token]);

  useEffect(() => {
    const indexOfLastProvider = currentPage * recordsPerPage;
    const indexOfFirstProvider = indexOfLastProvider - recordsPerPage;
    setCurrentLogs(
      viewAll ? logs : logs.slice(indexOfFirstProvider, indexOfLastProvider)
    );
  }, [currentPage, logs, viewAll]);

  const toggleViewAll = () => {
    setCurrentPage(1);
    setViewAll((pre) => !pre);
  };

  const viewAllButton = (
    <Button
      onClick={toggleViewAll}
      style={{
        backgroundColor: "#25BEFF",
        border: "none",
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 600,
        height: 36,
        width: 100,
      }}
    >
      {viewAll ? "Paginate" : "View All"}
    </Button>
  );

  return (
    <div className="container">
      <div className="bg-white rounded shadow-sm">
        <div className="app-page-toolbar">
          <h2 className="app-page-title">Audit Logs</h2>
        </div>
        <Table
          className="mb-0"
          hover
          responsive
          style={{ borderCollapse: "collapse", borderSpacing: 0 }}
        >
          <thead
            style={{
              backgroundColor: "#B760E5",
              color: "white",
              height: "50px",
              textAlign: "center",
            }}
          >
            <tr>
              <th style={{ width: "33%" }}>User ID</th>
              <th style={{ width: "10%" }}>User</th>
              <th style={{ width: "15%" }}>Device</th>
              <th style={{ width: "22%" }}>Action</th>
              <th style={{ width: "10%" }}>Date</th>
              <th style={{ width: "10%" }}>Time</th>
            </tr>
          </thead>
          <tbody
            style={{
              color: "#575757",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {currentLogs &&
              currentLogs.map((log, index) => (
                <tr
                  key={log.id}
                  style={{ backgroundColor: "white", height: 50 }}
                >
                  <td>{log.user_id}</td>
                  <td>{log.user_name}</td>
                  <td>{log.device}</td>
                  <td>{log.action}</td>
                  <td>{log.createdAt.split("T")[0]}</td>
                  <td>{new Date(log.createdAt).toLocaleTimeString()}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {viewAll ? (
          <div className="py-3 d-flex justify-content-end align-items-center px-4">
            {viewAllButton}
          </div>
        ) : (
          <TablePaginationBar
            currentPage={currentPage}
            totalItems={logs.length}
            rowsPerPage={recordsPerPage}
            onPageChange={paginate}
            leftExtra={viewAllButton}
          />
        )}
      </div>
    </div>
  );
};

export default AuditLogs;
